export enum LicenseFeature {
  Jails = 'JAILS',
  FibreChannel = 'FIBRECHANNEL',
  Dedup = 'DEDUP',
}
